import { useState } from "react";
import { Drawer } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import SideBarContent from "./SideBarContent";

/**
 * Mobile top bar (< lg). Shows brand + hamburger button that opens a Drawer
 * holding the same navigation as the desktop sidebar.
 */
function MobileTopBar() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <header className="lg:hidden flex items-center gap-3 h-14 px-4 bg-surface shadow-sm border-b sticky top-0 z-30">
                <button
                    type="button"
                    aria-label="Mở menu"
                    onClick={() => setOpen(true)}
                    className="w-9 h-9 flex items-center justify-center rounded-md text-content-2 hover:bg-surface-muted"
                >
                    <FontAwesomeIcon icon={faBars} className="w-5 h-5" />
                </button>
                <p className="text-base font-bold text-content m-0">Admin Panel</p>
            </header>

            <Drawer
                placement="left"
                open={open}
                onClose={() => setOpen(false)}
                width={260}
                styles={{ body: { padding: 0 } }}
                rootClassName="lg:hidden"
            >
                <SideBarContent onNavigate={() => setOpen(false)} />
            </Drawer>
        </>
    );
}

export default MobileTopBar;
